import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';

import styles from './bread-crumb-tooltip.module.scss';

type Props = {
  children: React.JSX.Element;
  allElementNames: string | Array<string>;
};

const BreadCrumbTooltip = ({ children, allElementNames }: Readonly<Props>): React.JSX.Element => {
  const allElementNamesArray = Array.isArray(allElementNames) ? allElementNames : [allElementNames];

  const renderTooltipTitle = (): React.JSX.Element => (
    <div className={styles.tooltip}>
      {allElementNamesArray.map((name, index, { length }) => (
        <React.Fragment key={`Breadcrumb_Tooltip_Child_${name}`}>
          <Typography className={styles.typography} variant="caption">
            {name}
          </Typography>
          {index + 1 < length && <ChevronRightIcon className={styles.chevronRightIcon} />}
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <Tooltip
      title={renderTooltipTitle()}
      followCursor
      slots={{
        transition: Zoom,
      }}
    >
      {children}
    </Tooltip>
  );
};

export default BreadCrumbTooltip;
